
import { RevIllustration } from '@ds/components/Illustration'
import { RevModal } from '@ds/components/Modal'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import translationsTrustList from '../TrustList/TrustList.translations'

import SatisfactionModalContent from './SatisfactionModalContent.vue'

export default {
  components: {
    RevIllustration,
    RevModal,
    SatisfactionModalContent,
  },

  props: {
    name: {
      type: String,
      default: MODAL_NAMES.REASSURANCE.SATISFACTION,
    },
  },

  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
    }),

    title() {
      return this.$t(translationsTrustList.satisfaction, {
        days: this.coolingOffDays,
      })
    },
  },
}
